import { render } from "./icon-scan.vue?vue&type=template&id=5b994218&scoped=true"
const script = {}

import "./icon-scan.vue?vue&type=style&index=0&id=5b994218&lang=scss&scoped=true"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/1/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b994218"]])

export default __exports__